"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var SignaturePopup_1 = require("./SignaturePopup");
var test_json_data_1 = require("./test_json_data");
var sweetalert2_1 = __importDefault(require("sweetalert2"));
console.log("Wrapper");
new SignaturePopup_1.SignaturePopup();
var submit_button = document.getElementById("submit_form_button");
if (submit_button) {
    submit_button.addEventListener("click", submit);
}
if (process.env.DEBUG === "true") {
    window.pdf.json_data = test_json_data_1.test_json_data;
}
var base_domain = window.location.protocol + "//" + window.location.hostname;
var secondary_json_data = {
    slug: process.env.SLUG,
    email_template_id: process.env.SLUG,
    pack_id: "naa_standalone_custom_task_application",
    acronym: process.env.ACRONYM_SLUG,
    form_type: "edularCore",
    version: "v3",
    start_date: "2020-11-30",
    campus: {
        id: 55,
        name: "New England"
    },
    forms: [
        {
            url: base_domain + "?form_id=disclosure",
            title: "Disclosures"
        }
    ]
};
var STANDALONE_CUSTOM_TASK_END_POINTS = {
    create: "custom-task/disclosure/create",
    answer: "custom-task/answer"
};
function submitWholeApplication(SUBMIT_TEXT, page, textPage, retry, textCounter, standaloneRequest, counter) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, status, body;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    textPage.textContent = SUBMIT_TEXT;
                    page.style.display = "flex";
                    page.style.zIndex = "99999";
                    retry.style.display = "block";
                    textCounter.textContent = "" + counter;
                    return [4, sendRequest(standaloneRequest.payload, "/v3/" + standaloneRequest.taskUri)];
                case 1:
                    _a = _b.sent(), status = _a.status, body = _a.body;
                    page.style.display = "none";
                    page.style.zIndex = "0";
                    if (status !== 200) {
                        document.getElementById("root").style.display = "block";
                        sweetalert2_1.default.fire({
                            icon: "warning",
                            title: "Error while submitting the form.",
                            text: "Something happened while submitting your form, please check. " + JSON.stringify(body),
                            width: "500px"
                        });
                        window.pdf.json_data.errors = body === null || body === void 0 ? void 0 : body.errors;
                        window.pdf["model"].dispatcher.dispatch();
                        return [2];
                    }
                    return [4, showSuccessPage(body._id, page, textPage, retry, window.pdf.json_data.type)];
                case 2: return [2, _b.sent()];
            }
        });
    });
}
function submit() {
    return __awaiter(this, void 0, void 0, function () {
        var check, page, textPage, textCounter, retry, SUBMIT_TEXT, standaloneRequest, _a, status_1, body, error_1, error_2, error_3, error_4, error_5;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    console.log("submit");
                    console.log(window.pdf.json_data);
                    return [4, window.pdf.validate()];
                case 1:
                    check = _b.sent();
                    if (!check) {
                        alert("Please check errors");
                        return [2];
                    }
                    document.getElementById("root").style.display = "none";
                    page = document.getElementById("success_page");
                    textPage = document.getElementById("wait_text");
                    textCounter = document.getElementById("retry_counter");
                    retry = document.getElementById("retry");
                    retry.style.display = "none";
                    SUBMIT_TEXT = "Please wait while we process your information.";
                    standaloneRequest = {
                        taskUri: "",
                        payload: {}
                    };
                    if (window.pdf.json_data.type === "student") {
                        standaloneRequest.taskUri = secondary_json_data.slug + "/" + STANDALONE_CUSTOM_TASK_END_POINTS.create;
                        standaloneRequest.payload = __assign(__assign({}, window.pdf.json_data), secondary_json_data);
                    }
                    else {
                        standaloneRequest.taskUri = "" + STANDALONE_CUSTOM_TASK_END_POINTS.answer;
                        standaloneRequest.payload = __assign({}, window.pdf.json_data);
                    }
                    _b.label = 2;
                case 2:
                    _b.trys.push([2, 20, , 21]);
                    textPage.textContent = SUBMIT_TEXT;
                    page.style.display = "flex";
                    page.style.zIndex = "99999";
                    return [4, sendRequest(standaloneRequest.payload, "/v3/" + standaloneRequest.taskUri)];
                case 3:
                    _a = _b.sent(), status_1 = _a.status, body = _a.body;
                    page.style.display = "none";
                    page.style.zIndex = "0";
                    if (status_1 !== 200) {
                        document.getElementById("root").style.display = "block";
                        sweetalert2_1.default.fire({
                            icon: "warning",
                            title: "Error while submitting the form.",
                            text: "Something happened while submitting your form, please check. " + JSON.stringify(body),
                            width: "500px"
                        });
                        window.pdf.json_data.errors = body === null || body === void 0 ? void 0 : body.errors;
                        window.pdf["model"].dispatcher.dispatch();
                        return [2];
                    }
                    _b.label = 4;
                case 4:
                    _b.trys.push([4, 6, , 19]);
                    return [4, showSuccessPage(body._id, page, textPage, retry, window.pdf.json_data.type)];
                case 5:
                    _b.sent();
                    return [3, 19];
                case 6:
                    error_1 = _b.sent();
                    _b.label = 7;
                case 7:
                    _b.trys.push([7, 9, , 18]);
                    return [4, submitWholeApplication(SUBMIT_TEXT, page, textPage, retry, textCounter, standaloneRequest, 1)];
                case 8:
                    _b.sent();
                    return [3, 18];
                case 9:
                    error_2 = _b.sent();
                    _b.label = 10;
                case 10:
                    _b.trys.push([10, 12, , 17]);
                    return [4, submitWholeApplication(SUBMIT_TEXT, page, textPage, retry, textCounter, standaloneRequest, 2)];
                case 11:
                    _b.sent();
                    return [3, 17];
                case 12:
                    error_3 = _b.sent();
                    _b.label = 13;
                case 13:
                    _b.trys.push([13, 15, , 16]);
                    return [4, submitWholeApplication(SUBMIT_TEXT, page, textPage, retry, textCounter, standaloneRequest, 3)];
                case 14:
                    _b.sent();
                    return [3, 16];
                case 15:
                    error_4 = _b.sent();
                    page.style.display = "none";
                    page.style.zIndex = "0";
                    retry.style.display = "none";
                    sweetalert2_1.default.fire({
                        icon: "error",
                        title: "Error while generating the pdf's.",
                        text: "Something happened while generating the pdf forms, please try again later.",
                        width: "500px"
                    }).then(function () {
                        document.getElementById("root").style.display = "block";
                    });
                    console.log(error_4);
                    return [3, 16];
                case 16: return [3, 17];
                case 17: return [3, 18];
                case 18: return [3, 19];
                case 19: return [3, 21];
                case 20:
                    error_5 = _b.sent();
                    page.style.display = "none";
                    page.style.zIndex = "0";
                    sweetalert2_1.default.fire({
                        icon: "error",
                        title: "Server down.",
                        text: "Our servers are down. Please try again later.",
                        width: "500px"
                    }).then(function () {
                        window.location.assign(process.env.BASE_DOMAIN);
                        location.reload();
                    });
                    return [3, 21];
                case 21: return [2];
            }
        });
    });
}
function sendRequest(json_data, url) {
    return __awaiter(this, void 0, void 0, function () {
        var rawResponse, body;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, fetch("" + process.env.API_DOMAIN + url, {
                        method: "POST",
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify(json_data)
                    })];
                case 1:
                    rawResponse = _a.sent();
                    return [4, rawResponse.json()];
                case 2:
                    body = _a.sent();
                    console.log(rawResponse.status);
                    console.log(body);
                    return [2, { status: rawResponse.status, body: body }];
            }
        });
    });
}
function showSuccessPage(id, page, textPage, retry, type) {
    return __awaiter(this, void 0, void 0, function () {
        var GENERATE_PDF, _a, staffMessage, studentMessage, e_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    GENERATE_PDF = "Please wait your PDF file is being generated.";
                    _a = [
                        "The Disclosure form has been sent.",
                        "Thank you for your submission. An advisor will contact you soon."
                    ], staffMessage = _a[0], studentMessage = _a[1];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    textPage.textContent = GENERATE_PDF;
                    page.style.display = "flex";
                    page.style.zIndex = "99999";
                    return [4, waitUntilJobComplete(id)];
                case 2:
                    _b.sent();
                    page.style.display = "none";
                    page.style.zIndex = "0";
                    retry.style.display = "none";
                    sweetalert2_1.default.fire({
                        icon: "success",
                        title: "Request sent",
                        text: type === "student" ? studentMessage : staffMessage,
                        width: "500px"
                    }).then(function () {
                        window.location.assign(process.env.BASE_DOMAIN);
                        location.reload();
                    });
                    return [3, 4];
                case 3:
                    e_1 = _b.sent();
                    console.log("@@@@@", e_1);
                    throw {
                        e: e_1
                    };
                case 4: return [2];
            }
        });
    });
}
function delay(duration) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2, new Promise(function (resolve, reject) {
                    setTimeout(function () {
                        resolve();
                    }, duration);
                })];
        });
    });
}
function waitUntilJobComplete(id) {
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            return [2, new Promise(function (resolve, reject) {
                    var interval_id = setInterval(function () { return __awaiter(_this, void 0, void 0, function () {
                        var status, body, r, e_2;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 2, , 3]);
                                    return [4, sendRequest({}, "/check/" + id)];
                                case 1:
                                    r = _a.sent();
                                    status = r.status;
                                    body = r.body;
                                    return [3, 3];
                                case 2:
                                    e_2 = _a.sent();
                                    clearInterval(interval_id);
                                    clearTimeout(timeout_id);
                                    reject(e_2);
                                    return [2];
                                case 3:
                                    console.log(body.jobs);
                                    if (status !== 200) {
                                        clearInterval(interval_id);
                                        clearTimeout(timeout_id);
                                        reject("Got status code not 200 from API");
                                    }
                                    if (body.jobs.status === "done") {
                                        clearInterval(interval_id);
                                        clearTimeout(timeout_id);
                                        resolve();
                                    }
                                    return [2];
                            }
                        });
                    }); }, 3000);
                    var timeout_id = setTimeout(function () {
                        clearInterval(interval_id);
                        reject(new Error("1 minute timeout reached"));
                    }, 60 * 1000);
                })];
        });
    });
}
//# sourceMappingURL=data:application/json;base64,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